
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/[tabName]",
      function () {
        return require("private-next-pages/account/[tabName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/[tabName]"])
      });
    }
  